import { render, staticRenderFns } from "./PageStatus.vue?vue&type=template&id=262a4d09&"
import script from "./PageStatus.vue?vue&type=script&lang=js&"
export * from "./PageStatus.vue?vue&type=script&lang=js&"
import style0 from "./PageStatus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports